import { Controller } from "@hotwired/stimulus";

/**
 * data-controller="tgrtrade"
 */

export default class extends Controller {
  connect() {
    const page = document.querySelector("#main");

    // "#main" がないページではここから下の処理を実行しない
    if (!page) return;

    // .header_categoryArea 実行
    $(".header_categoryArea > .ovf_scX").scroll((e) => {
      const scroll = e.target.scrollLeft;

      $(".ovf_btnLeft").css("left", scroll > 0 ? "0" : "-28px");

      $(".ovf_btnRight").css(
        "right",
        scroll < e.target.scrollWidth - e.target.clientWidth ? "0" : "-28px",
      );
    });
    $(".header_categoryArea > .ovf_btnLeft").click(() => {
      const target = $(".header_categoryArea > .ovf_scX").get(0);
      target.scrollTo({ left: 0, behavior: "smooth" });
    });
    $(".header_categoryArea > .ovf_btnRight").click(() => {
      const target = $(".header_categoryArea > .ovf_scX").get(0);
      target.scrollTo({
        left: target.scrollWidth - target.clientWidth,
        behavior: "smooth",
      });
    });

    // .footer > #sc_pageTop 実行
    $(window).scroll(() => {
      const scroll = window.scrollY;
      $("#sc_pageTop").css("bottom", scroll > 80 ? "18px" : "-44px");
    });
  }
}
